module.exports = __webpack_public_path__ + "img/chi-siamo-6.a7523922.jpg";